import { fromGender } from "@/src/services/formServiceFunctions";
import React from "react";
import summaryStyle from "./summaryStyle";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

type ContractualPartnerDataProps = {
  formData: Record<string, any>;
  title: string;
};

const ContractualPartnerData = ({ formData, title }: ContractualPartnerDataProps) => {
  const opposingPartyType = formData.opposingPartyType;
  const contractualPartner = opposingPartyType === "opposingPartyLegalEntity" ? formData.opposingPartyLegalEntity.organization : formData.opposingPartyPerson;
  const contractualPartnerEmail =
    opposingPartyType === "opposingPartyLegalEntity" ? formData.opposingPartyLegalEntity.organization.mainEmail.email : formData.opposingPartyPerson.email;
  const contractualPartnerAddress =
    opposingPartyType === "opposingPartyLegalEntity" ? formData.opposingPartyLegalEntity.organization.address : formData.opposingPartyPerson.residenceAddress;

  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h6"}>{title}</Typography>
      </Grid>
      {opposingPartyType === "opposingPartyLegalEntity" && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"name"} />
            <strong>Name Unternehmen</strong>
          </Grid>
          <Grid size={12}>{formData.opposingPartyLegalEntity.organization.legalName}</Grid>
        </>
      )}
      {opposingPartyType === "opposingPartyPerson" && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"gender"} />
            <strong>Anrede</strong>
          </Grid>
          <Grid size={12}>{fromGender(formData.opposingPartyPerson.gender) || "Keine Anrede"}</Grid>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"givenName"} />
            <strong>Vorname</strong>
          </Grid>
          <Grid size={12}>{formData.opposingPartyPerson.givenName}</Grid>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"familyName"} />
            <strong>Nachname</strong>
          </Grid>
          <Grid size={12}>{formData.opposingPartyPerson.familyName}</Grid>
        </>
      )}
      {contractualPartnerAddress.streetAddress && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"streetAddress"} />
            <strong>Straße und Hausnummer</strong>
          </Grid>
          <Grid size={12}>{contractualPartnerAddress.streetAddress}</Grid>
        </>
      )}
      {contractualPartnerAddress.postalCode && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"postalCode"} />
            <strong>Postleitzahl</strong>
          </Grid>
          <Grid size={12}>{contractualPartnerAddress.postalCode}</Grid>
        </>
      )}
      {contractualPartnerAddress.addressLocality && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"addressLocality"} />
            <strong>Ort</strong>
          </Grid>
          <Grid size={12}>{contractualPartnerAddress.addressLocality}</Grid>
        </>
      )}
      {contractualPartnerAddress.postOfficeBoxNumber && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"postOfficeBoxNumber"} />
            <strong>Postfach</strong>
          </Grid>
          <Grid size={12}>{contractualPartnerAddress.postOfficeBoxNumber}</Grid>
        </>
      )}
      {contractualPartnerAddress.postOfficeBoxPostalCode && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"postOfficeBoxPostalCode"} />
            <strong>Postfach PLZ</strong>
          </Grid>
          <Grid size={12}>{contractualPartnerAddress.postOfficeBoxPostalCode}</Grid>
        </>
      )}
      {contractualPartnerAddress.postOfficeBoxAddressLocality && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"postOfficeBoxAddressLocality"} />
            <strong>Postfach Ort</strong>
          </Grid>
          <Grid size={12}>{contractualPartnerAddress.postOfficeBoxAddressLocality}</Grid>
        </>
      )}
      {contractualPartnerEmail && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"email"} />
            <strong>E-Mail-Adresse</strong>
          </Grid>
          <Grid size={12}>{contractualPartnerEmail}</Grid>
        </>
      )}
      {contractualPartner.telephone && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"telephone"} />
            <strong>Telefonnummer</strong>
          </Grid>
          <Grid size={12}>{contractualPartner.telephone}</Grid>
        </>
      )}
    </>
  );
};

export default ContractualPartnerData;
